import { Button, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import CalenderIco from "../../../../../assets/icons/CalenderIco";
import ClipBoardCheck from "../../../../../assets/icons/ClipBoardCheckIco";
import { StyledFlexRowView } from "../../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../quick-match/components/StyledComponent";
import ScheduleInterview from "../../jobs-candidate/components/ScheduleInterview";
// import ScheduleInterview from "../../../jobs-candidate/components/ScheduleInterview";

function Actions({ matchedData }) {
  const [shareDialogOpen, setShareDialogOpen] = useState(false);

  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
  };

  // Open the dialog when Schedule Interview button is clicked
  const handleScheduleInterview = () => {
    setShareDialogOpen(true); // This will open the dialog
  };

  return (
    <div
      style={{
        marginTop: "16px",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        borderRadius: "12px",
        border: "1px solid #D0D5DD ",
      }}
    >
      <StyledSpaceBetweenBox
        sx={{ borderBottom: "1px solid #D0D5DD", padding: "12px" }}
      >
        <StyledFlexRowView>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#101828",
              display: "flex",
              alignItems: "center",
            }}
          >
            Actions for{" "}
            <span style={{ fontWeight: "bold", marginLeft: "4px" }}>
              {matchedData?.resume_info?.candidate_name}
            </span>
          </Typography>
        </StyledFlexRowView>
      </StyledSpaceBetweenBox>

      <div>
        <Grid2 container spacing={2} sx={{ padding: "12px" }}>
          <Grid2>
            <Button
              variant="outlined"
              size="small"
              startIcon={<CalenderIco />}
              sx={{
                padding: "10px 14px",
                borderRadius: "8px",
                marginTop: "24px",
                color: "#344054",
                fontSize: "14px",
                border: "1px solid #D0D5DD",
                fontWeight: "bold",
              }}
              onClick={handleScheduleInterview} // Handle button click to open dialog
            >
              {"Schedule Interview"}
            </Button>
          </Grid2>

          <Grid2>
            <Button
              variant="outlined"
              size="small"
              startIcon={<ClipBoardCheck />}
              sx={{
                padding: "10px 14px",
                borderRadius: "8px",
                marginTop: "24px",
                color: "#344054",
                fontSize: "14px",
                border: "1px solid #D0D5DD",
                fontWeight: "bold",
              }}
            >
              {"Conduct Test"}
            </Button>
          </Grid2>
        </Grid2>

        {/* Pass the state and close handler to the ShareQuickMatch component */}
        <ScheduleInterview
          open={shareDialogOpen}
          onClose={handleShareDialogClose}
          onApply={() => {
            handleShareDialogClose();
          }}
        />
      </div>
    </div>
  );
}

export default Actions;
